import React from "react";
import { FelaFlexbox } from "@gt/gt-frontend/build/react/vibescout-ui/fela/FelaFlexbox";
import { FelaFlexLayer } from "@gt/gt-frontend/build/react/vibescout-ui/fela/FelaLayers";
import { HeaderText, SubHeaderText } from "@gt/gt-frontend/build/react/vibescout-ui/common/BasicTextComponents";
import {
  EAppColor,
  EForeContrast,
  EFrontendStyleConfigBaseTheme,
  ESurfaceHeight,
  ETextSize,
} from "@gt/gt-frontend/build/react/vibescout-ui/config/VibescoutFrontendStyleConfig";
import { PostAsyncActions } from "../../state/asyncActions/PostAsyncActions";
import { FelaGrid } from "@gt/gt-frontend/build/react/vibescout-ui/fela/FelaGrid";
import { AsyncNavLink } from "../../state/ASN_VibescoutSpecial";
import { EButtonSize, FelaButton } from "@gt/gt-frontend/build/react/vibescout-ui/fela/FelaButton";
import { GoGraph } from "react-icons/go";
import { TempPostSearchSnippet } from "../../components/post/TempPostSearchSnippet";

interface ICPTemporarilyUnavailablePage {
  searchTerm: string;
}

export const TemporarilyUnavailablePage = React.memo<ICPTemporarilyUnavailablePage>(({ searchTerm }) => {
  // const { theme } = useFela<IFelaTheme>();
  // const { UIStore } = PSC_VibescoutSpecial.useStores();
  // const searchTerm = UIStore.useState((s) => s.pageMeta.searchTerm);
  const postSearch = PostAsyncActions.searchPost.use({ text: searchTerm! }, { dormant: searchTerm == null });

  console.log("Rendering Temporarily unavailable page");

  return (
    <FelaFlexbox direction={"column"} grow={1}>
      {/*<VibescoutHeader forceTitle={"Temporarily Unavailable"} noSharing={true} />*/}
      <FelaFlexbox grow={1} align={"center"} justify={"center"} direction={"column"}>
        <FelaFlexLayer
          shadow
          extraSoftShadow
          padding={0.5}
          radius={0.5}
          height={ESurfaceHeight.high}
          direction={"column"}
          align={"center"}
          margin={"1em 1em 3em 1em"}
        >
          <SubHeaderText size={ETextSize.content}>
            This page is under maintenance and currently unavailable
          </SubHeaderText>
          <SubHeaderText margin={"1em 0 0 0"} size={ETextSize.small}>
            We apologize for the inconvenience, we'll be sure to have it up soon enough!
          </SubHeaderText>
        </FelaFlexLayer>
        <SubHeaderText contrast={EForeContrast.strong} forceTheme={EFrontendStyleConfigBaseTheme.DARK}>
          In the meantime...
        </SubHeaderText>
        <AsyncNavLink to={"/reports/coronavirus"}>
          <FelaButton size={EButtonSize.regular} neutralColor={EAppColor.accent}>
            <GoGraph />
            <span>Detailed Covid 19 stats and graphs</span>
          </FelaButton>
        </AsyncNavLink>
        {postSearch.renderPayload(({ posts }) => {
          return (
            <FelaFlexbox direction={"column"} padding={0.5}>
              <HeaderText margin={1}>Some related content</HeaderText>
              <FelaGrid gap={0.5} gridTemplateColumns={"repeat(auto-fill, minmax(25em, 1fr))"}>
                {posts
                  .filter((p) => p.publishedUrl != null)
                  .sort((a, b) => b.dateLastPublished!.getTime() - a.dateLastPublished!.getTime())
                  .map((post) => (
                    <TempPostSearchSnippet
                      key={post.publishedUrl}
                      // isSmall={theme.isSmall}
                      post={post}
                    />
                  ))}
              </FelaGrid>
            </FelaFlexbox>
          );
        })}
      </FelaFlexbox>
    </FelaFlexbox>
  );
});
